import styled from "styled-components";


export const Container = styled.main`
  position: relative;
  z-index: 0;
  padding: 0 10rem;
  overflow-x: hidden;

  @media (max-width: 1200px){
    padding: 0 5rem;
  }

  @media (max-width: 740px){
    padding: 0 2.5rem;
  }

  @media(max-width: 480px){
    padding: 0 1.8rem;
  }

  @media(max-width: 360px){
    padding: 0 1.2rem;
  }
`